import React, { Fragment } from 'react';

const SCALAR_TYPES = {
  string: true,
  number: true,
  boolean: true
};
export function isScalar(value) {
  return !!SCALAR_TYPES[typeof value];
}

/**
 * React.render() must return a React element or null, so this function
 * can be used to return any other content like string, number, or array,
 * and it will wrap it in a <span> if needed or return it if already
 * can be rendered.
 *
 * @param expression Content to render
 * @return {*} Content, wrapped if necessary.
 */
export function wrapExpressionForRender(expression) {
  if (expression === null || expression === undefined) {
    return null;
  }
  if (Array.isArray(expression)) {
    return <Fragment>{expression}</Fragment>;
  }
  return isScalar(expression) ? <Fragment>{expression}</Fragment> : expression;
}

export function equiv(x, y) {
  if (x === y) {
    return true;
  }
  if (x === undefined || y === undefined) {
    return x === null || y === null;
  } else if (x === null || y === null) {
    return false;
  }
  // for date objects, but can apply to others and would be valid
  if (x.valueOf && y.valueOf) {
    return x.valueOf() === y.valueOf();
  }
  return false;
}

export const hasIntradayFail = (accounts) => {
  return accounts
    ?.map((account) => !!account?.pershingIntradayInvocationFailure && !account?.purgedAccount)
    ?.includes(true);
};
